import AddIcon from '@mui/icons-material/Add';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FolderIcon from '@mui/icons-material/Folder';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import RemoveIcon from '@mui/icons-material/Remove';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import React from 'react';

import { BtnColorType, BtnIconType, BtnTypeType, BtnVariantType } from './types';

type btnVariantColorReturnType = {
  variant: BtnVariantType;
  color: BtnColorType;
};

export const getVariantColorForBtn = (
  variant?: BtnVariantType,
  color?: BtnColorType,
  btnType?: BtnTypeType
) => {
  // if the verantos button type is set, then override the variant and color
  let variantColor: btnVariantColorReturnType;

  if (btnType) {
    switch (btnType) {
      case 'primary':
        variantColor = { variant: 'contained', color: 'primary' };
        return variantColor;
        break;
      case 'secondary':
        variantColor = { variant: 'contained', color: 'secondary' };
        return variantColor;
        break;
      case 'destructive':
        variantColor = { variant: 'contained', color: 'error' };
        return variantColor;

        break;
      case 'text':
        variantColor = { variant: 'contained', color: 'info' };
        return variantColor;
        break;
    }
  }

  variantColor = { variant: variant || 'contained', color: color || 'primary' };
  return variantColor;
};

export const getIconForButton = (btnIcon: BtnIconType) => {
  if (React.isValidElement(btnIcon)) {
    return btnIcon;
  }

  if (typeof btnIcon === 'string') {
    switch (btnIcon) {
      case 'add':
        return <AddIcon />;
        break;
      case 'cancel':
        return <CancelIcon />;
        break;
      case 'checkCircle':
        return <CheckCircleIcon />;
        break;
      case 'check':
        return <CheckIcon />;
        break;
      case 'calendar':
        return <CalendarTodayOutlinedIcon />;
      case 'folder':
        return <FolderIcon />;
        break;
      case 'progress':
        return <RefreshOutlinedIcon />;
        break;
      case 'radioBtnUnchecked':
        return <RadioButtonUncheckedOutlinedIcon />;
        break;
      case 'remove':
        return <RemoveCircleOutlineOutlinedIcon />;
        break;
      case 'warning':
        return <WarningOutlinedIcon />;
        break;
      case 'minus':
        return <RemoveIcon />;
      case 'back':
        return <NavigateBeforeIcon />;
    }
  }

  return undefined;
};
